enum HttpProviderType {
  Fetch = 'fetch'
}

export default HttpProviderType
